import { observable, action, toJS, computed } from "mobx";

export default class MemberLinkViewStore {
  constructor(http, searchStore) {
    this.http = http;
    this.searchStore = searchStore;
  }

  @observable
  entityData = observable.map();

  @action
  clearEntityData = () => {
    this.entityData = {};
  };

  getAsyncEntityData = async () => {
    const data = await this.entityData;
    return toJS(data);
  };

  @action
  fetchEntityDetailsWithoutCallback = async (type, tid) => {
    const params = {
      type: type,
      tid: tid,
      resultsInTree: true,
      resultsInBuckets: true,
    };
    await this.http.fetchEntityDetails(params, true).then((response) => {
      let data = JSON.parse(JSON.stringify(response));
      if (
        data &&
        data.item &&
        data.item.navigationLookupResult &&
        data.item.navigationLookupResult.navigationLookupRootItem &&
        data.item.navigationLookupResult.navigationLookupRootItem.items
      ) {
        this.entityData = data;
      }
    });
  };

  @computed
  get getEntityData() {
    return toJS(this.entityData);
  }
}
